import { render, staticRenderFns } from "./trawl-customer-service-layout.vue?vue&type=template&id=ce0af4da"
import script from "./trawl-customer-service-layout.vue?vue&type=script&lang=js"
export * from "./trawl-customer-service-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports